import React, { Component } from 'react';
import propTypes from 'prop-types';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  getVendors,
  fetchVendors,
  VendorsTable,
  updateVendor,
} from 'src/vendor';
import {
  setBreadcrumbs,
  reduceServerErrors,
  ConfirmDeletionModal,
  UiToastAdapter,
} from 'src/ui';
import { getUser, impersonateAccount } from 'src/user';
import { PagingManager } from 'src/api';

class AllVendorsListPage extends Component {
  state = {
    loading: true,
    archivingVendor: null,
    vendors: [],
  };

  constructor(props) {
    super(props);

    this.pagedVendors = new PagingManager(
      params => this.props.fetchVendors({ page: 1, pageSize: 10, ...params }), // eslint-disable-line react/destructuring-assignment
      () => this.props.vendors, // eslint-disable-line react/destructuring-assignment
      vendors => {
        this.setState({ vendors });
      }
    );
  }

  async componentDidMount() {
    const { setBreadcrumbs, impersonateAccount } = this.props;

    await impersonateAccount({});

    setBreadcrumbs([{ label: 'Vendors', href: '/all-vendors' }]);

    await this.pagedVendors.fetch();

    const { vendors } = this.props;
    if (vendors.isError()) {
      reduceServerErrors(vendors);
    }

    this.setState({ loading: false });
  }

  onArchive = vendor => {
    this.setState({ archivingVendor: vendor });
  };

  onCancelArchive = () => {
    this.setState({ archivingVendor: null });
  };

  onConfirmArchive = async () => {
    const { updateVendor } = this.props;
    const { archivingVendor } = this.state;

    this.setState({ loading: true });
    this.onCancelArchive();

    await updateVendor({
      vendorId: archivingVendor.id,
      isArchived: true,
    });

    const { vendors } = this.props;

    if (vendors.isError()) {
      reduceServerErrors(vendors);
    } else {
      toast(UiToastAdapter('Vendor archived successfully!', 'success'));
      await this.refreshAfterArchive();
    }

    this.setState({ loading: false });
  };

  refreshAfterArchive = async () => {
    const { page } = this.pagedVendors.getPaging();
    await this.pagedVendors.goToPage(page);

    const { vendors } = this.props;

    // the last page no longer exists when its only vendor was archived
    if (page > 1 && vendors.isError()) {
      await this.pagedVendors.goToPage(page - 1);
    }
  };

  onUpdate = async vendor => {
    const { updateVendor } = this.props;
    // the row is a display copy of the vendor, so only the decision is sent
    await updateVendor({
      vendorId: vendor.id,
      isApproved: vendor.isApproved,
      isDenied: vendor.isDenied,
    });

    const { vendors } = this.props;

    if (vendors.isError()) {
      reduceServerErrors(vendors);
    } else {
      this.pagedVendors.refresh();
      const message = `Vendor successfully ${
        vendor.isApproved ? 'approved' : 'denied'
      }!`;
      toast(UiToastAdapter(message, 'success'));
    }
  };

  render() {
    const { user } = this.props;
    const { loading, archivingVendor, vendors } = this.state;

    return (
      <div className="vendors">
        <Columns isMultiline>
          <Column isSize="1/2">
            <MuiTitle isSize="4" hasTextColor="info" tag="h2">
              All Vendors
            </MuiTitle>
          </Column>
          <Column hasTextAlign="right" isSize="1/2">
            <NavLink
              className="button is-gradient-bright is-long"
              to="/all-vendors/add"
            >
              <span className="icon">
                <FontAwesomeIcon icon={['fal', 'plus']} />
              </span>
              <span>New Vendor</span>
            </NavLink>
          </Column>
          <Column>
            <VendorsTable
              loading={loading}
              vendors={vendors}
              onArchive={this.onArchive}
              onUpdate={user.isBankAdmin ? this.onUpdate : null}
              isAllVendors
              paging={this.pagedVendors}
            />
          </Column>
        </Columns>
        <ConfirmDeletionModal
          isActive={!!archivingVendor}
          onClickCancel={this.onCancelArchive}
          onClickConfirm={this.onConfirmArchive}
          title={archivingVendor ? archivingVendor.businessName : ''}
        />
      </div>
    );
  }
}

AllVendorsListPage.propTypes = {
  user: propTypes.object.isRequired,
  vendors: propTypes.object.isRequired,
  fetchVendors: propTypes.func.isRequired,
  updateVendor: propTypes.func.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  impersonateAccount: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    vendors: getVendors(state),
  };
}

const connectedAllVendorsListPage = connect(mapStateToProps, {
  fetchVendors,
  setBreadcrumbs,
  updateVendor,
  impersonateAccount,
})(AllVendorsListPage);

export { connectedAllVendorsListPage as AllVendorsListPage };
